<script setup lang="ts">
import { useRouter } from "vue-router";
import BalloonIcon from "@/components/shared/icons/BalloonIcon.vue";
import SearchIcon from "@/components/shared/icons/SearchIcon.vue";
import { useTenantTheming } from "@/composables/useTenantTheming.js";

const router = useRouter();

const { secondaryColorClassButton } = useTenantTheming();

const redirectToResults = () => {
  router.push({ name: "results" });
};
</script>
<template>
  <div class="flex flex-col justify-center items-center gap-[4rem] p-[4rem] bg-white">
    <BalloonIcon />
    <div class="flex flex-col gap-4 justify-center items-center">
      <h1 class="font-bold text-[2.625rem]">No Experiences - Yet!</h1>
      <p class="font-medium text-sm text-center">
        The experience of a lifetime is waiting for you.<br />Discover and register for you perfect adventure.
      </p>
    </div>
    <button
      class="text-sm font-semibold text-white uppercase border "
      :class="secondaryColorClassButton"
      data-testid="find-experiences-button"
      @click="redirectToResults"
    >
      <div class="flex flex-row flex-nowrap items-center px-6 py-3 gap-2">
        <search-icon :size="17" />
        <span>Find the perfect experience</span>
      </div>
    </button>
  </div>
</template>
